import { Box, Dialog, DialogContent, DialogTitle, Paper, Stepper, TableCell } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "900px",
    width: "90%",
    height: "80vh",
    maxHeight: "800px"
  }
}))

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(3, 3, 0, 3),
  position: "relative"
}))

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3, 3, 3),
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  flex: 1,
  minHeight: 0
}))

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  flexShrink: 0
}))

export const StyledStepContent = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  minHeight: 0
}))

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
  marginTop: theme.spacing(2)
}))

export const StyledSummarySection = styled(Box)(({ theme }) => ({
  // marginBottom: theme.spacing(3)
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: 0,
  paddingRight: 0,
  fontWeight: 400
}))

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  fontWeight: 600,
  fontSize: theme.typography.bodyMedium.fontSize,
  width: "33.3%"
}))

export const StyledVehicleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "selectedVehiclesList"
})<any>(({ theme, selectedVehiclesList }) => ({
  border: "1px solid",
  borderColor: theme.palette.grey[300],
  borderRadius: "8px",
  padding: theme.spacing(2),
  marginRight: selectedVehiclesList.length > 2 ? theme.spacing(2) : 0
}))
